import React from 'react';
import Layout from './Layout';
import { css } from '@emotion/core';
import Container from './Container';
import Article from './Article';
import { rhythm } from '../styles/util';
import { MQ } from 'src/styles/constants'
import { padded, clearFix } from '../styles/util';
import SEO from './Seo'

const twoCol = css`
  ${MQ.gt.MD} {
    ${clearFix}

    > {
      p, ol, ul, blockquote, code, h2, h3, h4, h5, h6 {
        width: 65%;
        float: right;
        margin-top: 0;
      }
    }

    > .gatsby-resp-image-wrapper {
      position: relative;
      right: ${rhythm(1)};
      width: 35%;
      margin: ${rhythm(1)} 0 !important;
    }
  }
`

const AsideLayout = ({title, description, children}) => {
  let hasImages = false;
  React.Children.forEach(children, child => {
    if (child.type === 'span' && child.props.className === 'gatsby-resp-image-wrapper') {
      hasImages = true;
    }
  });

  return (
    <Layout>
      <SEO title={title} description={description} />
      <Container width={hasImages ? '1100px' : '750px'} >
        <Article css={hasImages && twoCol}>
          <h1>{title}</h1>
          {children}
        </Article>
      </Container>
    </Layout> 
  )
};

export default AsideLayout;